
<div class="container">
  <dx-tabs
      #withText
      [width]="'100%'"
      [selectedIndex]="0"
      [rtlEnabled]="false"
      [scrollByContent]="true"
      [showNavButtons]="true"
      [dataSource]="tabsWithText"
      [orientation]="'horizontal'"
      [stylingMode]="'primary'"
      [iconPosition]=""
      (onSelectionChanged)="onSelectionChanged($event)"
    ></dx-tabs>

<!-- Current -->
<div class="dx-card-no-border" *ngIf="selectedTabIndex === 0">
  <div class="dx-card-header">
    <h2>Current</h2>
  </div>
  <div class="dx-card-content">

  <div class="image-wrapper-container">
    <div *ngIf="video">
      <div class="close-button">
      </div>
      <video autoplay controls src="{{ videoFile }}"></video>
    </div>
    <div *ngIf="currentImageData; else loadin1">

        <div class="dx-card" *ngFor="let image of currentImageData.uploadedFiles; let i = index">
          <div class="dx-card-header" *ngIf="currentImageData.nationality">
            {{ currentImageData.nationality }}
          </div>
          <div class="dx-card-content">

            <div [ngSwitch]="image.uploadedFileStatusDescription">
              <div *ngSwitchCase="'Active'">
                <div class="bottom-container">
                  <div class="titles">
                    <div class="info-container">
                      <p style="margin-right: 10px; font-weight: bold">Updated by:</p>
                      <p style="margin-right: 20px">
                        {{ image.updatedByString }}
                      </p>
                    </div>

                    <div class="info-container">
                      <p style="margin-right: 10px">Updated on:</p>
                      <p style="margin-right: 20px">
                        {{ image.updatedOnString }}
                      </p>
                    </div>

                    <div class="info-container">
                      <p style="margin-right: 10px">Status:</p>
                      <p style="margin-right: 20px">
                        {{ image.uploadedFileStatusDescription }}
                      </p>
                    </div>
                  </div>

                  <div class="buttons-container">
                    <ng-container *appCheckPermission="null; permissions: ['legalentity.member.edit']; requireLegalEntityContext: false">
                      <dx-button id="open-upload-doc-button"
                          class="open-button"
                          text="Open"
                          stylingMode="contained"
                          type="default"
                          icon=""
                          (onClick)="openFileInBrowser(image)">
                      </dx-button>
                      <div *ngIf="image.uploadedFileId">  
                        <dx-button
                          text="Replace" class="replace-button"
                          stylingMode="contained"
                          type="default"
                          icon=""
                          (onClick)="openReplacePopup(image, 'replace')">
                        </dx-button>
                      </div>
                      <dx-button
                          text="Replace" class="replace-button"
                          stylingMode="contained"
                          type="default"
                          icon=""
                          (onClick)="openReplacePopup(image, 'replace')">
                        </dx-button>
                    </ng-container>
                    <ng-container *appCheckPermission="null; permissions: ['fica.verify']; requireLegalEntityContext: false">

                        <dx-button id="approve-uploaded-doc-button"
                            class="approve-button"
                            text="Approve"
                            stylingMode="contained"
                            type="success"
                            icon=""
                            (onClick)="
                            imageApproveFunction(
                              image.uploadedFileId,
                              image.userIdentityId,
                              image.uploadedFileTypeDescription,
                              image.uploadedFileTypeId
                            )
                          ">
                        </dx-button>
                        <dx-button id="reject-uploaded-doc-button"
                            class="reject-button"
                            text="Reject"
                            stylingMode="contained"
                            type="danger"
                            icon=""
                            (onClick)="declineDocument(image.uploadedFileId, image.uploadedFileTypeDescription, image.uploadedFileTypeId)">
                        </dx-button>

                    </ng-container>
                  </div>
                </div>
              </div>

              <div *ngSwitchCase="'Pending'">
                <div class="bottom-container">
                  <div class="titles">
                    <div class="info-container">
                      <p style="margin-right: 10px; font: bold">Updated by:</p>
                      <p style="margin-right: 20px">
                        {{ image.updatedByString }}
                      </p>
                    </div>

                    <div class="info-container">
                      <p style="margin-right: 10px">Updated on:</p>
                      <p style="margin-right: 20px">
                        {{ image.updatedOnString }}
                      </p>
                    </div>

                    <div class="info-container">
                      <p style="margin-right: 10px">Status:</p>
                      <p style="margin-right: 20px">
                        {{ image.uploadedFileStatusDescription }}
                      </p>
                    </div>
                  </div>

                  <div class="buttons-container">
                    <ng-container *appCheckPermission="null; permissions: ['legalentity.member.edit']; requireLegalEntityContext: false">
                      <dx-button id="open-upload-doc-button"
                        text="Open"
                        class="open-button"
                        stylingMode="contained"
                        type="default"
                        icon=""
                        (onClick)="openFileInBrowser(image)">
                      </dx-button>
                      <div *ngIf="image.uploadedFileId">  
                        <dx-button
                          text="Replace" class="replace-button"
                          stylingMode="contained"
                          type="default"
                          icon=""
                          (onClick)="openReplacePopup(image, 'replace')">
                        </dx-button>
                      </div>
                    </ng-container>
                      <ng-container *appCheckPermission="null; permissions: ['fica.verify']; requireLegalEntityContext: false">

                        <dx-button id="approve-uploaded-doc-button"
                          text="Approve"
                          class="approve-button"
                          stylingMode="contained"
                          type="success"
                          icon=""
                          (onClick)="
                          imageApproveFunction(
                            image.uploadedFileId,
                            image.userIdentityId,
                            image.uploadedFileTypeDescription,
                            image.uploadedFileTypeId
                          )
                        ">
                        </dx-button>
                        <dx-button id="reject-uploaded-doc-button"
                          text="Reject"
                          class="reject-button"
                          stylingMode="contained"
                          type="danger"
                          icon=""
                          (onClick)="declineDocument(image.uploadedFileId, image.uploadedFileTypeDescription, image.uploadedFileTypeId)">
                        </dx-button>

                    </ng-container>
                  </div>
                </div>
              </div>

              <div *ngSwitchCase="'Verified'">
                <div class="bottom-container">
                  <div class="titles">
                    <div class="info-container">
                      <p style="margin: 0px 10px 0px 0px; font: bold">Updated by:</p>
                      <p style="margin: 0px 20px 0px 0px">
                        {{ image.updatedByString }}
                      </p>
                    </div>

                    <div class="info-container">
                      <p style="margin: 0px 10px 0px 0px">Updated on:</p>
                      <p style="margin: 0px 20px 0px 0px">
                        {{ image.updatedOnString }}
                      </p>
                    </div>

                    <div class="info-container">
                      <p style="margin: 0px 10px 0px 0px">Status:</p>
                      <p style="margin: 0px 20px 0px 0px">
                        {{ image.uploadedFileStatusDescription }}
                      </p>
                    </div>
                  </div>
                  <div class="buttons-container" *ngIf="image.uploadedFileStatusDescription !== 'No image'">
                    <ng-container *appCheckPermission="null; permissions: ['legalentity.member.edit']; requireLegalEntityContext: false">
                      <dx-button id="open-uploaded-doc-button"
                        class="open-button"
                        text="Open"
                        stylingMode="contained"
                        type="warning"
                        icon=""
                        (onClick)="openFileInBrowser(image)">
                      </dx-button>  
                      <div *ngIf="image.uploadedFileId">  
                      <dx-button
                          text="Replace" class="replace-button"
                          stylingMode="contained"
                          type="default"
                          icon=""
                          (onClick)="openReplacePopup(image, 'replace')">
                        </dx-button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>

              <div *ngSwitchCase="'Rejected'">
                <div *ngIf="image.fileName === 'This customer has no profile picture on record'">
                  <h2>This customer has no profile picture on record</h2>
                </div>

                <div class="badges" *ngIf="image.uploadedFileStatusDescription === 'Rejected'; else emptyIcon">
                  <i class="dx-icon-clearcircle"></i>
                </div>

                <div class="rejectReason">
                  <div class="rejection-reason">Rejection Reason:</div>
                  <div>{{ image.rejectReason }}</div>
                </div>

                <div class="rejectReasonExtra">
                  <div class="extra-info">Extra Info:</div>
                  <div>{{ image.rejectReasonExtraInfo }}</div>
                </div>

                <div class="rejectReasonPrivate">
                  <div class="private-note">Admin Private note:</div>
                  <div>{{ image.rejectReasonAdminPrivateNotes }}</div>
                </div>

                <div class="bottom-container">
                  <div class="titles">
                    <p style="margin-right: 10px; font: bold">Updated by:</p>
                    <p style="margin-right: 20px">
                      {{ image.updatedByString }}
                    </p>
                    <p style="margin-right: 10px">Updated on:</p>
                    <p style="margin-right: 20px">
                      {{ image.updatedOnString }}
                    </p>
                    <p style="margin-right: 10px">Status:</p>
                    <p style="margin-right: 20px">
                      {{ image.uploadedFileStatusDescription }}
                    </p>
                  </div>
                  <div class="buttons-container">
                    <ng-container *appCheckPermission="null; permissions: ['legalentity.member.edit']; requireLegalEntityContext: false">
                      <dx-button id="open-uploaded-doc-after-approved-button"
                        class="open-button"
                        text="Open"
                        stylingMode="contained"
                        type="warning"
                        icon=""
                        (onClick)="openFileInBrowser(image)">
                      </dx-button>
                      <div *ngIf="image.uploadedFileId">  
                        <dx-button
                          text="Replace" class="replace-button"
                          stylingMode="contained"
                          type="default"
                          icon=""
                          (onClick)="openReplacePopup(image, 'replace')">
                        </dx-button>
                      </div>
                    </ng-container>
                  </div>
                </div>

              </div>

              <div *ngSwitchCase="'Not Uploaded'">
                <div class="bottom-container">
                  <div class="titles">
                    <div class="info-container">
                      <p style="margin: 0px 10px 0px 0px">Status:</p>
                      <p style="margin: 0px 20px 0px 0px">
                        {{ image.uploadedFileStatusDescription }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="buttons-container">
                    <ng-container *appCheckPermission="null; permissions: ['legalentity.member.edit']; requireLegalEntityContext: false">
                      <div *ngIf="image.uploadedFileId">
                      <dx-button
                        text="Upload"
                        stylingMode="contained"
                        type="default"
                        icon="" class="replace-button"
                        (onClick)="openReplacePopup(image, 'upload')">
                      </dx-button>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div *ngSwitchCase="'No image'">
                <div class="bottom-container">
                  <div class="titles">
                    <div class="info-container">
                      <p style="margin: 0px 10px 0px 0px">Status1:</p>
                      <p style="margin: 0px 20px 0px 0px">
                        {{ image.uploadedFileStatusDescription }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="buttons-container">
                    <ng-container *appCheckPermission="null; permissions: ['legalentity.member.edit']; requireLegalEntityContext: false">
                      <div *ngIf="image.uploadedFileId">
                        <dx-button
                          text="Upload"
                          stylingMode="contained"
                          type="default"
                          icon="" class="replace-button"
                          (onClick)="openReplacePopup(image, 'upload')">
                        </dx-button>
                      </div>
                  </ng-container>
                </div>
              </div>
            </div>


          </div>
        </div>

    </div>
    <ng-template #loadin1>
      <p>No current image data found.</p>
    </ng-template>
  </div>
  </div>
</div>

<!-- Archived -->
<div class="dx-card-no-border" *ngIf="selectedTabIndex === 1">
  <div class="dx-card-header">
    <h2>Archived</h2>
  </div>
  <div class="dx-card-content">
    <div class="image-wrapper-container">
      <div *ngIf="imagesForPrevious && imagesForPrevious.length>0; else loadin2">
        <div *ngFor="let previousDocs of imagesForPrevious; let i = index">
          <div *ngIf="previousDocs.uploadedFiles && previousDocs.uploadedFiles.length>0; else loadin2">
            <div class="dx-card" *ngFor="let image of previousDocs.uploadedFiles; let i = index">
              <div *ngIf="image.uploadedFileStatusDescription === 'Rejected'">
                <div *ngIf="image.fileName === 'This customer has no profile picture on record'">
                  <h2>This customer has no profile picture on record</h2>
                </div>

                <div class="badges" *ngIf="image.uploadedFileStatusDescription === 'Rejected'; else emptyIcon">
                  <i class="dx-icon-clearcircle"></i>
                </div>

                <div class="rejectReason">
                  <div class="rejection-reason">Rejection Reason:</div>
                  <div>{{ image.rejectReason }}</div>
                </div>

                <div class="rejectReasonExtra">
                  <div class="extra-info">Extra Info:</div>
                  <div>{{ image.rejectReasonExtraInfo }}</div>
                </div>

                <div class="rejectReasonPrivate">
                  <div class="private-note">Admin Private note:</div>
                  <div>{{ image.rejectReasonAdminPrivateNotes }}</div>
                </div>

                <div class="bottom-container">
                  <div class="titles">
                    <p style="margin-right: 10px; font: bold">Updated by:</p>
                    <p style="margin-right: 20px">
                      {{ image.updatedByString }}
                    </p>
                    <p style="margin-right: 10px">Updated on:</p>
                    <p style="margin-right: 20px">
                      {{ image.updatedOnString }}
                    </p>
                    <p style="margin-right: 10px">Status:</p>
                    <p style="margin-right: 20px">
                      {{ image.uploadedFileStatusDescription }}
                    </p>
                  </div>
                  <div class="buttons-container" *ngIf="image.uploadedFileStatusDescription !== 'No image'">
                    <ng-container *appCheckPermission="null; permissions: ['fica.view']; requireLegalEntityContext: false">
                      <dx-button id="open-uploaded-doc-after-approved-button"
                        class="open-button"
                        text="Open"
                        stylingMode="contained"
                        type="warning"
                        icon=""
                        (onClick)="openFileInBrowser(image)">
                      </dx-button>
                    </ng-container>
                  </div>
                </div>
              </div>

              <div *ngIf="image.uploadedFileStatusDescription !== 'Rejected'">
                <div *ngIf="image.fileName === 'This customer has no profile picture on record'">
                  <h2>This customer has no profile picture on record</h2>
                </div>

                <div class="badges" *ngIf="image.uploadedFileStatusDescription === 'Rejected'">
                </div>

                <div class="bottom-container">
                  <div class="titles">
                    <div class="info-container">
                      <p style="margin-right: 10px; font: bold">Updated by:</p>
                      <p style="margin-right: 20px">
                        {{ image.updatedByString }}
                      </p>
                    </div>
                    <div class="info-container">
                      <p style="margin-right: 10px">Updated on:</p>
                      <p style="margin-right: 20px">
                        {{ image.updatedOnString }}
                      </p>
                    </div>
                    <div class="info-container">
                      <p style="margin-right: 10px">Status:</p>
                      <p style="margin-right: 20px">
                        {{ image.uploadedFileStatusDescription }}
                      </p>
                    </div>
                  </div>
                  <div class="buttons-container" *ngIf="image.uploadedFileStatusDescription !== 'No image'">
                    <ng-container *appCheckPermission="null; permissions: ['fica.view']; requireLegalEntityContext: false">
                      <dx-button id="open-uploaded-doc-after-approved-button"
                        class="open-button"
                        text="Open"
                        stylingMode="contained"
                        type="warning"
                        icon=""
                        (onClick)="openFileInBrowser(image)">
                      </dx-button>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #loadin2>
        <p>No previous images found.</p>
      </ng-template>
    </div>
  </div>
</div>


<ng-template #loading>
<p>no data available</p>
</ng-template>

</div>
<ng-template #emptyIcon>
<div class="badges-title-panel-green">
<i (click)="close()" class="dx-icon-check"></i>
</div>
</ng-template>


<dx-popup
  [(visible)]="displayRejectModal"
  [width]="560"
  [height]="'auto'"
  [maxHeight]="600"
  [showTitle]="true"
  [showCloseButton]="true"
  titleTemplate="title"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true">
  <div *dxTemplate="let data of 'title'" class="dx-popup-header popup-title-row">
    <h2>Document rejection</h2>
    <i class="dx-icon-close popup-close-icon" aria-hidden="true" (click)="closeRejectionPop()"></i>
  </div>
  <div *dxTemplate="let data of 'content'">
    <div *ngIf="rejectionReason$ | async as rejection" class="document-rejection-popup document-rejection-popup--sticky-footer">
      <div class="document-rejection-popup__scroll">
      <p class="document-rejection-popup__lead">
        Choose a rejection reason and enter a message for the employee. Both are required before you can reject this document.
      </p>

      <div class="document-rejection-popup__section">
        <span class="document-rejection-popup__label document-rejection-popup__label--required">Rejection reason</span>
        <div
          class="document-rejection-popup__field"
          [class.document-rejection-popup__field--invalid]="showRejectionReasonError">
          <dx-select-box
            class="document-rejection-popup__control"
            [dataSource]="rejection"
            [(value)]="option"
            displayExpr="description"
            valueExpr="id"
            [searchEnabled]="true"
            [showClearButton]="false"
            placeholder="Select a reason"
            (onValueChanged)="selected($event)">
          </dx-select-box>
        </div>
        <div *ngIf="showRejectionReasonError" class="document-rejection-popup__error" role="alert">
          Please select a rejection reason.
        </div>
      </div>

      <div class="document-rejection-popup__section">
        <span class="document-rejection-popup__label document-rejection-popup__label--required">Message to employee</span>
        <div class="document-rejection-popup__notice document-rejection-popup__notice--employee" role="note">
          <i class="dx-icon-info"></i>
          <span>This text is sent to the employee with the rejection.</span>
        </div>
        <div
          class="document-rejection-popup__field"
          [class.document-rejection-popup__field--invalid]="showEmployeeMessageError">
          <dx-text-area
            [(value)]="reason"
            class="document-rejection-popup__textarea"
            [height]="120"
            placeholder="Enter the message the employee will receive (required).">
          </dx-text-area>
        </div>
        <div *ngIf="showEmployeeMessageError" class="document-rejection-popup__error" role="alert">
          Please enter a message for the employee.
        </div>
      </div>

      <div class="document-rejection-popup__section">
        <span class="document-rejection-popup__label">Private admin notes</span>
        <div class="document-rejection-popup__notice document-rejection-popup__notice--internal" role="note">
          <i class="dx-icon-lock"></i>
          <span>Visible only to administrators — not shown to the employee.</span>
        </div>
        <div class="document-rejection-popup__field document-rejection-popup__field--private-notes">
          <input
            type="text"
            class="document-rejection-popup__input"
            placeholder="Internal notes (optional)"
            [(ngModel)]="privateNotes"
            autocomplete="off" />
        </div>
      </div>

      </div>

      <div class="document-rejection-popup__actions document-rejection-popup__actions--footer">
        <dx-button text="Cancel" stylingMode="outlined" type="default" (onClick)="closeRejectionPop()"></dx-button>
        <dx-button
          text="Reject document"
          stylingMode="contained"
          type="danger"
          (onClick)="saveRejectionReason()">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>

<!-- Upload / Replace Proof of Address popup -->
<dx-popup
[(visible)]="displayReplaceModal"
[width]="600"
[height]="400"
[showTitle]="true"
[showCloseButton]="true"
titleTemplate="title"
[dragEnabled]="true"
[hideOnOutsideClick]="true"
>
<div *dxTemplate="let data of 'title'" class="dx-popup-header popup-title-row">
  <h2>{{ addressProofPopupTitle }}</h2>
  <i class="dx-icon-close popup-close-icon" aria-hidden="true" (click)="closeReplacePopup()"></i>
</div>
<div *dxTemplate="let data of 'content'">
  <div class="replace-modal-content">
    <div class="form-section">
      <label class="form-label">Document Type *</label>
      <dx-select-box
        [dataSource]="proofOfAddressDocumentTypes$ | async"
        [(value)]="selectedDocumentTypeId"
        valueExpr="id"
        displayExpr="description"
        searchEnabled="true"
        showClearButton="true"
        placeholder="Select Document Type"
        acceptCustomValue="true"
        (onValueChanged)="onDocumentTypeChanged($event)"
        (onCustomItemCreating)="customProofOfAddressDocumentTypeHandler($event)"
        noDataText="No document types found"
        width="100%">
      </dx-select-box>
      <small style="color: #666; font-size: 11px; display: block; margin-top: 2px;">
        {{ addressProofDocumentTypeHint }}
      </small>
    </div>

    <div class="form-section">
      <label class="form-label">{{ addressProofFileFieldLabel }}</label>
      <dx-file-uploader
        #replaceFileUploader
        name="{{ fileNameFICA }}"
        uploadMethod="PUT"
        [uploadHeaders]="headers"
        uploadMode="useButtons"
        [(uploadUrl)]="uploadFICAURL"
        accept=".png, .jpg, .jpeg, .pdf, .heic, .heif"
        maxFileSize="15727100"
        [multiple]="false"
        (onValueChanged)="onReplaceFileValueChanged($event)"
        (onUploaded)="onReplaceUploadSuccess()"
        (onUploadError)="errorUploadedAddressProof(replaceFileUploader, $event)"
        [uploadButtonText]="isAddressProofUploadModal ? 'Upload' : 'Replace'"
        [selectButtonText]="isAddressProofUploadModal ? 'Choose File' : 'Choose File'"
        invalidFileExtensionMessage="File type is not allowed"
        invalidMaxFileSizeMessage="File is too large"
        invalidMinFileSizeMessage="File is too small"
        labelText=""
        width="100%"
        showFileList="true"
        [disabled]="!selectedDocumentTypeId || !currentFileToReplace?.uploadedFileId">
      </dx-file-uploader>
    </div>

    <div class="form-section">
      <div class="file-info" *ngIf="currentFileToReplace">
        <h4>{{ addressProofCurrentFileSectionTitle }}:</h4>
        <p><strong>File Name:</strong> {{ currentFileToReplace.fileName }}</p>
        <p><strong>Status:</strong> {{ currentFileToReplace.uploadedFileStatusDescription }}</p>
        <p><strong>Updated:</strong> {{ currentFileToReplace.updatedOnString }}</p>
      </div>
    </div>

    <div class="btn-container">
      <dx-button
        text="Close"
        stylingMode="outlined"
        type="default"
        (onClick)="closeReplacePopup()"
        style="margin: 8px">
      </dx-button>
      <dx-button
        [text]="addressProofPrimaryButtonText"
        stylingMode="contained"
        type="default"
        [disabled]="!selectedDocumentTypeId || !currentFileToReplace?.uploadedFileId || !replaceFileSelected"
        (onClick)="executeReplaceUpload()"
        style="margin: 8px">
      </dx-button>
    </div>
  </div>
</div>
</dx-popup>

